import { CreditsPolicy } from './policy';
import { CREDIT_MULTIPLIERS } from './constants';
export function buildDefaultCreditsContext(currentUser) {
  const creditsPolicy = new CreditsPolicy(currentUser, undefined);
  return {
    creditsPolicy,
    currentUser,
    errorId: null,
    isLoaded: false,
    creditAuthorization: {
      DATASET_ENRICHMENT: false,
      INTENT_MONITORING: false,
      SMART_PROPERTY_RUN: false
    }
  };
}
export const convertToUnixEpoch = dateArray => {
  const [year, month, day] = dateArray;
  const date = new Date(Date.UTC(year, month - 1, day));
  const unixEpoch = Math.floor(date.getTime());
  return unixEpoch;
};
export const convertStringToUnixEpoch = date => {
  const dateObject = new Date(date);
  const unixEpoch = Math.floor(dateObject.getTime());
  return unixEpoch;
};
export const getCreditCountForAction = (action, creditCount) => {
  if (action === 'DATASET_ENRICHMENT' || action === 'SMART_PROPERTY_RUN' || action === 'INTENT_MONITORING') {
    return creditCount * CREDIT_MULTIPLIERS[action];
  }
  return creditCount;
};
export const getCreditCountPerAction = action => {
  if (action === 'DATASET_ENRICHMENT' || action === 'SMART_PROPERTY_RUN' || action === 'INTENT_MONITORING') {
    return CREDIT_MULTIPLIERS[action];
  }
  return 0;
};
export const getDaysToReset = endDate => {
  if (!endDate) {
    return 0;
  }
  const now = new Date();
  const resetDate = new Date(endDate);
  const daysToReset = Math.ceil((resetDate.getTime() - now.getTime()) / (1000 * 60 * 60 * 24));
  return Math.max(daysToReset, 0);
};